import React from 'react'
import { reduxForm } from 'redux-form'
import styles from './Forms.css'
import TextInput from './components/TextInput'
import TextAreaInput from './components/TextAreaInput'
import MaskedInput from './components/MaskedInput'
import ReactSelectDropdownInput from './components/ReactSelectDropdownInput'
import {
  emailMask,
  phoneNumberMask,
  emailValidation,
  phoneValidation,
  minLen1Validation,
  notJustSpacesValidation,
  validateZipCode,
  getDateOfBirthMask,
  dateValidation,
  notesLenValidation,
} from './components/formValidations'
import { getName } from '../Utilities'
import {
  US_STATES,
  UNASSIGNED_ORDERING_PHYSICIAN_OPTION,
  FORM_SEX_OPTIONS,
  getDateOfBirthFormat,
} from '../../constants'
import { filterIsPhysicianPermission } from '../../store/appReducer'
import InputField, {
  InputFieldPlaceholder,
} from './components/InputField/InputField'
import SaveIcon from 'static/images/icons/content-save.svg'
import Loading from '../../components/Loading'

class EditIDTFPatientForm extends React.Component {
  constructor(props) {
    super(props)
    // Initial disabled state for custom fields
    this.state = {
      disabled: {
        firstName: true,
        lastName: true,
        middleName: true,
        customParticipantID: true,
        sex: true,
        email: true,
        socialSecurityNumber: true,
        dob: true,
        orderingPhysician: true,
        phone: true,
        notes: true,
        alternatePhone: true,
        emergencyContactName: true,
        emergencyContactPhone: true,
        patientAddressLine1: true,
        patientAddressLine2: true,
        patientCity: true,
        patientState: true,
        patientZip: true,
        shippingAddressLine1: true,
        shippingAddressLine2: true,
        shippingCity: true,
        shippingState: true,
        shippingZip: true,
        primaryInsuranceType: true,
        primaryMedicareId: true,
        primaryInsuranceCompanyName: true,
        primaryInsuranceGroup: true,
        primaryInsuranceAuthorizationNumber: true,
        primaryPolicyHolderName: true,
        primaryPolicyHolderRelationship: true,
        primarySubscriberId: true,
        secondaryInsuranceType: true,
        secondaryMedicareId: true,
        secondaryInsuranceCompanyName: true,
        secondaryInsuranceGroup: true,
        secondaryInsuranceAuthorizationNumber: true,
        secondaryPolicyHolderName: true,
        secondaryPolicyHolderRelationship: true,
        secondarySubscriberId: true,
      },
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.submitSucceeded !== this.props.submitSucceeded &&
      nextProps.submitSucceeded === true
    ) {
      this.setState({
        disabled: {
          firstName: true,
          lastName: true,
          middleName: true,
          customParticipantID: true,
          sex: true,
          email: true,
          dob: true,
          socialSecurityNumber: true,
          orderingPhysician: true,
          phone: true,
          notes: true,
          alternatePhone: true,
          emergencyContactName: true,
          emergencyContactPhone: true,
          patientAddressLine1: true,
          patientAddressLine2: true,
          patientCity: true,
          patientState: true,
          patientZip: true,
          shippingAddressLine1: true,
          shippingAddressLine2: true,
          shippingCity: true,
          shippingState: true,
          shippingZip: true,
          primaryInsuranceType: true,
          primaryMedicareId: true,
          primaryInsuranceCompanyName: true,
          primaryInsuranceGroup: true,
          primaryInsuranceAuthorizationNumber: true,
          primaryPolicyHolderName: true,
          primaryPolicyHolderRelationship: true,
          primarySubscriberId: true,
          secondaryInsuranceType: true,
          secondaryMedicareId: true,
          secondaryInsuranceCompanyName: true,
          secondaryInsuranceGroup: true,
          secondaryInsuranceAuthorizationNumber: true,
          secondaryPolicyHolderName: true,
          secondaryPolicyHolderRelationship: true,
          secondarySubscriberId: true,
        },
      })
    }
  }

  toggleDisable = field => {
    this.setState(prevState => ({
      disabled: Object.assign(prevState.disabled, {
        [field]: !prevState.disabled[field],
      }),
    }))
  }

  render() {
    const {
      handleSubmit,
      invalid,
      pristine,
      submitting,
      isSubmitting,
      me,
      physicians,
    } = this.props

    const { disabled } = this.state
    let physicianOptions = [ UNASSIGNED_ORDERING_PHYSICIAN_OPTION ]

    if (physicians && physicians.data) {
      physicianOptions = [
        ...physicianOptions,
        ...filterIsPhysicianPermission(
          physicians.data.sortedByLastName.map(id => physicians.data.byId[id]),
        ),
      ]
    }

    const PRIMARY_INSURANCE_TYPE_OPTIONS = [
      { value: 'self_pay', label: 'Self pay' },
      { value: 'medicare', label: 'Medicare' },
      { value: 'commercial_insurance', label: 'Commercial Insurance' },
    ]

    const SECONDARY_INSURANCE_TYPE_OPTIONS = [
      { value: 'none', label: 'None' },
      { value: 'medicare', label: 'Medicare' },
      { value: 'commercial_insurance', label: 'Commercial Insurance' },
    ]
    return (
      <form onSubmit={handleSubmit}>
        <React.Fragment>
          <div className={styles.editPatientSection}>
            <div className={styles.formSectionRow}>
              <InputField
                component={TextInput}
                label="First Name"
                name="firstName"
                placeholder="Enter First Name"
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={TextInput}
                label="Last Name"
                name="lastName"
                placeholder="Enter Last Name"
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={TextInput}
                label="Middle Name"
                name="middleName"
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
            </div>
          </div>
          <div className={styles.editPatientSection}>
            <div className={styles.formSectionRow}>
              <InputField
                component={TextInput}
                label="Patient MRN"
                name="customParticipantID"
                validate={[ notJustSpacesValidation ]}
                disabled={disabled}
                required={true}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={TextInput}
                mask={emailMask}
                label="SSN"
                name="socialSecurityNumber"
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={ReactSelectDropdownInput}
                label="Sex"
                name="sex"
                placeholder="Select a sex"
                options={FORM_SEX_OPTIONS}
                noOptionsMessage="No Sex found"
                getOptionLabel={p => p.label}
                getOptionValue={p => p.value}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
            </div>
            <div className={styles.formSectionRow}>
              <InputField
                component={MaskedInput}
                mask={getDateOfBirthMask(me)}
                placeholder={getDateOfBirthFormat(me)}
                label="Date of Birth"
                name="dob"
                validate={[ dateValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={ReactSelectDropdownInput}
                label="Ordering Provider"
                name="orderingPhysician"
                isLoading={physicians && physicians.isFetching}
                isClearable={false}
                backspaceRemovesValue={false}
                placeholder="Unassigned"
                options={physicianOptions}
                noOptionsMessage="No provider found"
                getOptionLabel={p =>
                  getName(p.firstName, p.lastName, p.customParticipantID)
                }
                getOptionValue={p => p.id}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputFieldPlaceholder />
            </div>
          </div>
          <div className={styles.editPatientSection}>
            <InputField
              component={TextAreaInput}
              label="Notes"
              name="notes"
              placeholder="Enter Notes"
              validate={[ notesLenValidation ]}
              disabled={disabled}
              toggleDisable={this.toggleDisable}
            />
          </div>
          <div className={styles.editPatientSection}>
            <div className={styles.formSectionRow}>
              <InputField
                component={MaskedInput}
                mask={phoneNumberMask}
                placeholder="XXX-XXX-XXXX"
                label="Primary Phone Number"
                name="phone"
                validate={[ phoneValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={MaskedInput}
                mask={phoneNumberMask}
                placeholder="XXX-XXX-XXXX"
                label="Alternate Phone Number"
                name="alternatePhone"
                validate={[ phoneValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={MaskedInput}
                mask={emailMask}
                placeholder="name@example.com"
                label="Email"
                name="email"
                validate={[ emailValidation, minLen1Validation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
            </div>
            <div className={styles.formSectionRow}>
              <InputField
                component={TextInput}
                label="Emergency Contact Name"
                name="emergencyContactName"
                validate={[ notJustSpacesValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={MaskedInput}
                mask={phoneNumberMask}
                placeholder="XXX-XXX-XXXX"
                label="Emergency Contact Number"
                name="emergencyContactPhone"
                validate={[ phoneValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputFieldPlaceholder />
            </div>
          </div>
          <div className={styles.editPatientSection}>
            <div className={styles.formSectionRow}>
              <InputField
                component={TextInput}
                label="Patient Address Line 1"
                name="patientAddressLine1"
                validate={[ notJustSpacesValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={TextInput}
                label="Patient Address Line 2"
                name="patientAddressLine2"
                validate={[ notJustSpacesValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={TextInput}
                label="patient City"
                name="patientCity"
                validate={[ notJustSpacesValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
            </div>
            <div className={styles.formSectionRow}>
              <InputField
                component={ReactSelectDropdownInput}
                label="patient State"
                name="patientState"
                placeholder="Select a state"
                options={US_STATES}
                noOptionsMessage="No State found"
                getOptionLabel={p => `${p.name} - ${p.code}`}
                getOptionValue={p => p.code}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={TextInput}
                label="patient ZIP"
                name="patientZip"
                validate={[ validateZipCode, notJustSpacesValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputFieldPlaceholder />
            </div>
            <div className={styles.formSectionRow}>
              <InputField
                component={TextInput}
                label="shipping Address Line 1"
                name="shippingAddressLine1"
                validate={[ notJustSpacesValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={TextInput}
                label="shipping Address Line 2"
                name="shippingAddressLine2"
                validate={[ notJustSpacesValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={TextInput}
                label="shipping City"
                name="shippingCity"
                validate={[ notJustSpacesValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
            </div>
            <div className={styles.formSectionRow}>
              <InputField
                component={ReactSelectDropdownInput}
                label="shipping State"
                name="shippingState"
                placeholder="Select a state"
                options={US_STATES}
                noOptionsMessage="No State found"
                getOptionLabel={p => `${p.name} - ${p.code}`}
                getOptionValue={p => p.code}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputField
                component={TextInput}
                label="shipping ZIP"
                name="shippingZip"
                validate={[ validateZipCode, notJustSpacesValidation ]}
                disabled={disabled}
                toggleDisable={this.toggleDisable}
              />
              <InputFieldPlaceholder />
            </div>
          </div>
          <div>
            <div className={styles.formTop}>
              <h2 className={styles.formTitle}>Insurance</h2>
            </div>
            <div className={styles.editPatientSection}>
              <div className={styles.formSectionRow}>
                <InputField
                  component={ReactSelectDropdownInput}
                  label="Primary Insurance Type"
                  name="primaryInsuranceType"
                  placeholder="Select Insurance Type"
                  options={PRIMARY_INSURANCE_TYPE_OPTIONS}
                  noOptionsMessage="No Insurance Type found"
                  getOptionLabel={p => p.label}
                  getOptionValue={p => p.value}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Insurance Company Name"
                  name="primaryInsuranceCompanyName"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Insurance Group"
                  name="primaryInsuranceGroup"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
              </div>
              <div className={styles.formSectionRow}>
                <InputField
                  component={TextInput}
                  label="Insurance Authorization Number"
                  name="primaryInsuranceAuthorizationNumber"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Policy Holder Name"
                  name="primaryPolicyHolderName"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Policy Holder Relationship"
                  name="primaryPolicyHolderRelationship"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
              </div>
              <div className={styles.formSectionRow}>
                <InputField
                  component={TextInput}
                  label="Subscriber/Policy/Member ID"
                  name="primarySubscriberId"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Medicare Id Number"
                  name="primaryMedicareId"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputFieldPlaceholder />
              </div>
            </div>
            <div className={styles.editPatientSection}>
              <div className={styles.formSectionRow}>
                <InputField
                  component={ReactSelectDropdownInput}
                  label="Secondary Insurance Type"
                  name="secondaryInsuranceType"
                  placeholder="Select Insurance Type"
                  options={SECONDARY_INSURANCE_TYPE_OPTIONS}
                  noOptionsMessage="No Insurance Type found"
                  getOptionLabel={p => p.label}
                  getOptionValue={p => p.value}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Insurance Company Name"
                  name="secondaryInsuranceCompanyName"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Insurance Group"
                  name="secondaryInsuranceGroup"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
              </div>
              <div className={styles.formSectionRow}>
                <InputField
                  component={TextInput}
                  label="Insurance Authorization Number"
                  name="secondaryInsuranceAuthorizationNumber"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Policy Holder Name"
                  name="secondaryPolicyHolderName"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Policy Holder Relationship"
                  name="secondaryPolicyHolderRelationship"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
              </div>
              <div className={styles.formSectionRow}>
                <InputField
                  component={TextInput}
                  label="Subscriber/Policy/Member ID"
                  name="secondarySubscriberId"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputField
                  component={TextInput}
                  label="Medicare Id Number"
                  name="secondaryMedicareId"
                  validate={[ notJustSpacesValidation ]}
                  disabled={disabled}
                  toggleDisable={this.toggleDisable}
                />
                <InputFieldPlaceholder />
              </div>
            </div>
          </div>
        </React.Fragment>

        <div className={styles.submitWrapper}>
          <div className={styles.buttonWrapper}>
            {submitting || isSubmitting ? (
              <button disabled className={styles.submitLoading}>
                <Loading />
              </button>
            ) : (
              <button
                type="submit"
                disabled={invalid || pristine}
                className={styles.submit}
                data-action="button-edit-profile"
                data-label="save"
              >
                <SaveIcon />
                Save
              </button>
            )}
          </div>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'EditPatientIDTFForm',
  enableReinitialize: true,
})(EditIDTFPatientForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/EditIDTFPatientForm.jsx